export default {
  name: 'Organization Name',
  edit: {
    form: 'name-input',
    label: 'Change the name',
    handler: value => value,
  },
};
